import { C } from "./theme";
import { hue } from "./hue";
import { LineIcon } from "./kindIcons";

// A tile that opens one destination: an icon top left, a chevron top right, the title under the icon
// and its line below, washed in the tile's hue. Titles start at the same height, so a line that wraps
// doesn't push its title out of step with the tile beside it. Home and Learn share it.
// `bright` mixes a stronger wash and border from the same hue tokens (Home, Craig 16 Oct 2026:
// "make the colours a little bit brighter").
// A tile with no onClick is coming soon: it isn't a button and has no chevron, and its line says so. Home draws
// those without `bright`, so they sit quieter than the tiles that open something.
// `compact` is Home's: the icon sits beside the title instead of above it, so all twelve tiles fit above the bottom bar
// on a phone (Craig, 24 Oct 2026: "reduce the height of the tiles on the home page slightly so they all fit above the
// fold", then two more tiles). Home's grid then stretches them to fill the screen. It has no chevron: every Home tile
// opens a page, and the coloured card already reads as something to tap, so its words get the whole width. On a
// narrow phone the icon and a long one-word title ("Temptations") wrap onto two lines rather than collide.
export function Tile({ title, sub, icon, hueName, iconHue, onClick, bright = false, compact = false }) {
  const Tag = onClick ? "button" : "div";
  const h = hue(hueName);
  const wash = bright ? `color-mix(in srgb, ${h.b} 45%, ${C.surface})` : h.w;
  const edge = bright ? `color-mix(in srgb, ${h.c} 45%, ${C.surface})` : h.b;
  const glyph = (
    <span aria-hidden="true" style={{ color: hue(iconHue || hueName).c, lineHeight: 0, flexShrink: 0, ...(compact ? {} : { position: "absolute", top: 13, left: 14 }) }}>
      <LineIcon paths={icon} />
    </span>
  );
  const name = <span style={{ fontSize: 17, fontWeight: 700, lineHeight: 1.2, color: C.text }}>{title}</span>;
  return (
    <Tag onClick={onClick}
      style={{ position: "relative", display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start", gap: compact ? 4 : 3,
        minHeight: compact ? 62 : 116, padding: compact ? "11px 12px" : "50px 14px 14px", borderRadius: 14, border: `1px solid ${edge}`, background: wash, textAlign: "left", cursor: onClick ? "pointer" : "default", fontFamily: "inherit" }}>
      {compact
        ? <span style={{ display: "flex", flexWrap: "wrap", alignItems: "center", columnGap: 7, rowGap: 4 }}>{glyph}{name}</span>
        : <>{glyph}{name}</>}
      <span style={{ fontSize: 13, lineHeight: 1.35, color: C.textMid }}>{sub}</span>
      {onClick && !compact && <span aria-hidden="true" style={{ position: "absolute", top: 11, right: 14, color: C.textDim, fontSize: 19, lineHeight: 1 }}>›</span>}
    </Tag>
  );
}
